import axios from "axios";
import { BASEURL } from "baseUrl";
import { toast } from "react-toastify";
import { medicinePackage } from "./Doctor.action";

export const ADD_FEEDBACK = 'ADD_FEEDBACK'
export const VIEW_FEEDBACK_BY_ID = 'VIEW_FEEDBACK_BY_ID'
export const DELETE_FEEDBACK = 'DELETE_FEEDBACK'
export const UPDATE_FEEDBACK = 'UPDATE_FEEDBACK'
export const VIEW_FEEDBACK = 'VIEW_FEEDBACK'
export const GET_ALL_FEEDBACK = 'GET_ALL_FEEDBACK'
export const GET_ALL_DIAGNOSIS = 'GET_ALL_DIAGNOSIS'
export const ADD_ALL_DIAGNOSIS = 'ADD_ALL_DIAGNOSIS'
export const SHOW_ALL_DIAGNOSIS = 'SHOW_ALL_DIAGNOSIS'
export const UPDATE_ALL_DIAGNOSIS = 'UPDATE_ALL_DIAGNOSIS'
export const GET_ALL_MEDICINE = 'GET_ALL_MEDICINE'
export const SEARCH_MEDICINE = 'SEARCH_MEDICINE'
export const ADD_MEDICINE = 'ADD_MEDICINE'
export const VIEW_MEDICINE = 'VIEW_MEDICINE'
export const DELETE_MEDICINE = 'DELETE_MEDICINE'
export const UPDATE_MEDICINE = 'UPDATE_MEDICINE'
export const DELETE_ALL_DIAGNOSIS = 'DELETE_ALL_DIAGNOSIS'
export const SEARCH_ALL_DIAGNOSIS = 'SEARCH_ALL_DIAGNOSIS'

const addFeedbackAction = (payload) => ({ type: ADD_FEEDBACK, payload: payload });
const viewAllFeedbackByIdAction = (payload) => ({ type: VIEW_FEEDBACK_BY_ID, payload: payload });
const deleteFeedbackction = (payload) => ({ type: DELETE_FEEDBACK, payload: payload });
const updateFeedbackction = (payload) => ({ type: UPDATE_FEEDBACK, payload: payload });
const viewFeedbackction = (payload) => ({ type: VIEW_FEEDBACK, payload: payload });
const getAllFeedbackction = (payload) => ({ type: GET_ALL_FEEDBACK, payload: payload });
const getAllDiagnosisAction = (payload) => ({ type: GET_ALL_DIAGNOSIS, payload: payload });
const addAllDiagnosisAction = (payload) => ({ type: ADD_ALL_DIAGNOSIS, payload: payload });
const showAllDiagnosisAction = (payload) => ({ type: SHOW_ALL_DIAGNOSIS, payload: payload });
const updateAllDiagnosisAction = (payload) => ({ type: UPDATE_ALL_DIAGNOSIS, payload: payload });
const getAllMedicineAction = (payload) => ({ type: GET_ALL_MEDICINE, payload: payload });
const searchMedicineAction = (payload) => ({ type: SEARCH_MEDICINE, payload: payload });
const addMedicineAction = (payload) => ({ type: ADD_MEDICINE, payload: payload });
const viewMedicineAction = (payload) => ({ type: VIEW_MEDICINE, payload: payload });
const deleteMedicineAction = (payload) => ({ type: DELETE_MEDICINE, payload: payload });
const updateMedicineAction = (payload) => ({ type: UPDATE_MEDICINE, payload: payload });

const deleteAllDiagnosisAction = (payload) => ({ type: DELETE_ALL_DIAGNOSIS, payload: payload });
const searchAllDiagnosisAction = (payload) => ({ type: SEARCH_ALL_DIAGNOSIS, payload: payload });

export const addFeedback = (payload, patientIds, selectedPatientId, limits) => {
    return async (dispatch) => {
        try {
            const token = localStorage.getItem('token')
            await axios.post(`${BASEURL}/clinical/addfeedBack`, payload, {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            }).then(((res) => {
                toast.success('Add Feedback Successfully')
                dispatch(addFeedbackAction(res));
                dispatch(getAllFeedback(selectedPatientId, limits))
                // dispatch(viewFeedback(selectedPatientId))
            })).catch((error) => {
                console.log("Error", error);
                toast.error(error?.response?.data?.message)
                dispatch(addFeedbackAction(error?.response));
            });
        } catch (error) {
            toast.error(error?.response)
            console.log('Error login user:', error);
        }
    }
}

export const viewFeedbackById = (patientIds, limits) => {

    return async (dispatch) => {
        try {
            await axios.get(`${BASEURL}/receptionist/getPatientFeedback/${patientIds}?limit=${limits.limit}&page=${limits.page}`).then(((res) => {
                dispatch(viewAllFeedbackByIdAction(res));
            })).catch((error) => {
                console.log("Error", error);
                dispatch(viewAllFeedbackByIdAction(error?.response));
            });
        } catch (error) {
            toast.error(error?.response)
            console.log('Error login user:', error);
        }
    }
}

export const deleteFeedback = (feedbackId, patientIds, limits) => {
    return async (dispatch) => {
        try {
            await axios.delete(`${BASEURL}/clinical/deleteFeedback/${feedbackId}`).then(((res) => {
                dispatch(deleteFeedbackction(res));
                dispatch(getAllFeedback(patientIds, limits))
                toast.success('Delete Feedback Successfully')
            })).catch((error) => {
                console.log("Error", error);
                toast.error(error?.response?.data?.message)
                dispatch(deleteFeedbackction(error?.response));
            });
        } catch (error) {
            toast.error(error?.response)
            console.log('Error login user:', error);
        }
    }
}

export const updateFeedback = (payload, feedbackId, patientIds, limits) => {
    return async (dispatch) => {
        try {
            const token = localStorage.getItem('token')
            await axios.put(`${BASEURL}/clinical/updateFeedback/${feedbackId}`, payload, {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            }).then(((res) => {
                dispatch(updateFeedbackction(res));
                dispatch(getAllFeedback(patientIds, limits))
                toast.success('Update Feedback Successfully')
            })).catch((error) => {
                console.log("Error", error);
                toast.error(error?.response?.data?.message)
                dispatch(updateFeedbackction(error?.response));
            });
        } catch (error) {
            toast.error(error?.response)
            console.log('Error login user:', error);
        }
    }
}

export const viewFeedback = (feedbackId) => {
    return async (dispatch) => {
        try {
            await axios.get(`${BASEURL}/clinical/viewFeedback/${feedbackId}`).then(((res) => {
                dispatch(viewFeedbackction(res));
            })).catch((error) => {
                console.log("Error", error);
                dispatch(viewFeedbackction(error?.response));
            });
        } catch (error) {
            toast.error(error?.response)
            console.log('Error login user:', error);
        }
    }
}

export const getAllFeedback = (patientIds, limits) => {
    return async (dispatch) => {
        try {
            await axios.get(`${BASEURL}/clinical/viewAllFeedback/${patientIds}?page=${limits.page}&limit=${limits.limit}`).then(((res) => {
                dispatch(getAllFeedbackction(res));
            })).catch((error) => {
                console.log("Error", error);
                dispatch(getAllFeedbackction(error?.response));
            });
        } catch (error) {
            toast.error(error?.response)
            console.log('Error login user:', error);
        }
    }
}


export const getAllDiagnosis = () => {
    return async (dispatch) => {
        try {
            await axios.get(`${BASEURL}/master/dropDownGetAllDiagnosis`).then(((res) => {
                dispatch(getAllDiagnosisAction(res));
            })).catch((error) => {
                console.log("Error", error);
                dispatch(getAllDiagnosisAction(error?.response));
            });
        } catch (error) {
            toast.error(error?.response)
            console.log('Error login user:', error);
        }
    }
}

export const addAllDiagnosis = (payload, patientIds, limits) => {
    return async (dispatch) => {
        try {
            const token = localStorage.getItem('token')
            await axios.post(`${BASEURL}/clinical/createPatientDiagnosis`, payload, {
                headers: { authorization: `Bearer ${token}` }
            }).then(((res) => {
                dispatch(addAllDiagnosisAction(res));
                dispatch(showAllDiagnosis(patientIds, limits))
                toast.success('Add Diagnosis Sussessfully')
            })).catch((error) => {
                console.log("Error", error);
                toast.error(error?.response?.data?.message)
                dispatch(addAllDiagnosisAction(error?.response));
            });
        } catch (error) {
            toast.error(error?.response)
            console.log('Error login user:', error);
        }
    }
}

export const showAllDiagnosis = (patientIds, limits) => {
    return async (dispatch) => {
        try {
            await axios.get(`${BASEURL}/clinical/getAllPatientDiagnoses/${patientIds}?limit=${limits.limit}&page=${limits.page}`).then(((res) => {
                dispatch(showAllDiagnosisAction(res));
            })).catch((error) => {
                console.log("Error", error);
                dispatch(showAllDiagnosisAction(error?.response));
            });
        } catch (error) {
            toast.error(error?.response)
            console.log('Error login user:', error);
        }
    }
}

export const updateAllDiagnosis = (payload, ids, patientIds, limits) => {
    return async (dispatch) => {
        try {
            const token = localStorage.getItem('token')
            await axios.put(`${BASEURL}/clinical/updatePatientDiagnosis/${ids}`, payload, {
                headers: { authorization: `Bearer ${token}` }
            }).then(((res) => {
                dispatch(updateAllDiagnosisAction(res));
                dispatch(showAllDiagnosis(patientIds, limits))
                toast.success('Update Diagnosis Sussessfully')
            })).catch((error) => {
                console.log("Error", error);
                dispatch(updateAllDiagnosisAction(error?.response));
            });
        } catch (error) {
            toast.error(error?.response)
            toast.error(error?.response?.data?.message)
            console.log('Error login user:', error);
        }
    }
}

export const getAllMedicine = () => {
    return async (dispatch) => {
        try {
            await axios.get(`${BASEURL}/master/getAllMedicineWithoutPagination`).then(((res) => {
                dispatch(getAllMedicineAction(res));
            })).catch((error) => {
                console.log("Error", error);
                dispatch(getAllMedicineAction(error?.response));
            });
        } catch (error) {
            console.log('Error login user:', error);
        }
    }
}

export const searchMedicine = (params) => {
    return async (dispatch) => {
        try {
            await axios.get(`${BASEURL}/master/searchMed?search=${params}`).then(((res) => {
                dispatch(searchMedicineAction(res));
            })).catch((error) => {
                console.log("Error", error);
                dispatch(searchMedicineAction(error?.response));
            });
        } catch (error) {
            console.log('Error login user:', error);
        }
    }
}

export const addMedicine = (payload, patientIds, limits) => {
    return async (dispatch) => {
        try {
            const token = localStorage.getItem('token')
            await axios.post(`${BASEURL}/clinical/addPatientMedicines`, payload, {
                headers: {
                    authorization: `Bearer ${token}`
                }
            }).then(((res) => {
                dispatch(addMedicineAction(res));
                dispatch(viewMedicine(patientIds, limits))
                dispatch(medicinePackage(patientIds))
                toast.success('Add Medicine Sussessfully')
            })).catch((error) => {
                console.log("Error", error);
                dispatch(addMedicineAction(error?.response));
            });
        } catch (error) {
            toast.error(error?.response)
            toast.error(error?.response?.data?.message)
            console.log('Error login user:', error);
        }
    }
}

export const deleteAllDiagnosis = (ids, patientIds, limits) => {
    return async (dispatch) => {
        try {
            await axios.delete(`${BASEURL}/clinical/deletePatientDiagnosis/${ids}`).then(((res) => {
                dispatch(deleteAllDiagnosisAction(res));
                dispatch(showAllDiagnosis(patientIds, limits))
                toast.success('Delete Diagnosis Sussessfully')
            })).catch((error) => {
                console.log("Error", error);
                toast.error(error?.response?.data?.message)
                dispatch(deleteAllDiagnosisAction(error?.response));
            });
        } catch (error) {
            toast.error(error?.response)
            console.log('Error login user:', error);
        }
    }
}

export const viewMedicine = (patientIds, limits) => {
    return async (dispatch) => {
        try {
            await axios.get(`${BASEURL}/clinical/viewPatientMedicines/${patientIds}?page=${limits.page}&limit=${limits.limit}`).then(((res) => {
                dispatch(viewMedicineAction(res));
            })).catch((error) => {
                console.log("Error", error);
                dispatch(viewMedicineAction(error?.response));
            });
        } catch (error) {
            console.log('Error login user:', error);
        }
    }
}

export const deleteMedicine = (limits, patientIds, payload, mainId) => {
    return async (dispatch) => {
        try {
            await axios.post(`${BASEURL}/clinical/deletePatientMedicines/${mainId}`, payload).then(((res) => {
                dispatch(deleteMedicineAction(res));
                dispatch(medicinePackage(patientIds))
                toast.success('Delete Medicine Sussessfully')
                dispatch(viewMedicine(patientIds, limits))
            })).catch((error) => {
                console.log("Error", error);
                toast.error(error?.response?.data?.message)
                dispatch(deleteMedicineAction(error?.response));
            });
        } catch (error) {
            toast.error(error?.response)
            console.log('Error login user:', error);
        }
    }
}

export const updateMedicine = (mainId, payload, patientIds, limits) => {
    return async (dispatch) => {
        try {
            const token = localStorage.getItem('token')
            await axios.put(`${BASEURL}/clinical/updatePatientMedicine/${mainId}`, payload, {
                headers: {
                    authorization: `Bearer ${token}`
                }
            }).then(((res) => {
                dispatch(updateMedicineAction(res));
                dispatch(medicinePackage(patientIds))
                // toast.success('Update Medicine Sussessfully')
                dispatch(viewMedicine(patientIds, limits))
            })).catch((error) => {
                console.log("Error", error);
                toast.error(error?.response?.data?.message)
                dispatch(updateMedicineAction(error?.response));
            });
        } catch (error) {
            toast.error(error?.response)
            console.log('Error login user:', error);
        }
    }
}

export const searchAllDiagnosis = (params) => {
    return async (dispatch) => {
        try {
            await axios.get(`${BASEURL}/master/searchDiagnosisWithoutPagination?search=${params.search}`).then(((res) => {
                dispatch(searchAllDiagnosisAction(res));
            })).catch((error) => {
                console.log("Error", error);
                dispatch(searchAllDiagnosisAction(error?.response));
            });
        } catch (error) {
            toast.error(error?.response)
            console.log('Error login user:', error);
        }
    }
}